export enum HttpVerb {
  get = 'get',
  post = 'post',
  put = 'put',
  delete = 'delete',
}
